
export default {
	name: 'LandingPagePawPrintTrail',
	props: {
		isHorizontal: {
			type: Boolean,
			default: true
		}
	},
	data () {
			return {
					totalFootPrints: 0,
					currentLeftPaw: 0,
					currentRightPaw: 0,
					isResizedCounter: 0
			}
	},
	mounted() {
		this.calculateTotalPaws(window)
		$(window).on('resize', e =>{
			this.calculateTotalPaws(this.isHorizontal ? e.currentTarget.innerWidth : document.body.scrollHeight)
		})
	},
	methods: {
		calculateTotalPaws(e) {
			this.isResizedCounter++
			this.totalFootPrints = parseInt(e.innerWidth / this.isHorizontal ? 82 : 32)
		},
		getPawPlacement(index) {
			const result = index % 4;
			if (result === 1) {
					return 'transform: rotate(90deg);'
			} else if (result === 2) {
					return 'transform: translateY(-1.5rem) rotate(70deg);'
			}  else if (result === 3) {
					return 'transform: translateY(-3rem) rotate(90deg);'
			}  else if (result === 0) {
					return 'transform: translateY(-1.5rem) rotate(100deg);'
			}
		}
	}
}